/**
 * Returns an item with the correct styling needed to generate an item.
 * @param {*String} item
 */
export default function getItemStyles(itemType) {
    let itemStyle = {};

    switch (itemType) {
      case 'tour':
        itemStyle = {
          backgroundColor: "#4F5AF6",
          color: 'white',
          borderStyle: "solid",
          borderColor: "white"
        };
        break;
      case 'meal':
        itemStyle = {
          backgroundColor: '#0AC798',
          color: 'black',
          borderStyle: "solid",
          borderColor: "white"
        };
        break;
      case 'overtime':
        itemStyle = {
          backgroundColor: '#FF4500',
          color: 'white',
          borderStyle: "solid",
          borderColor: "white"
        };
        break;
      case 'no-info':
        itemStyle = {
          backgroundColor: '#748893',
          color: 'white',
          borderStyle: "solid",
          borderColor: "white"
        };
        break;
      case 0: // first in 3 rotating styles for
        itemStyle = {
          backgroundColor: '#F89CEF',
          color: "black",
          borderStyle: "solid",
          borderColor: "white"
        };
        break;
      case 1:
        itemStyle = {
          backgroundColor: '#65FDFC',
          color: "black",
          borderStyle: "solid",
          borderColor: "white"
        };
        break;
      case 2:
        itemStyle = {
          backgroundColor: '#FACA9B',
          color: "black",
          borderStyle: "solid",
          borderColor: "white"
        };
        break;
      case 3:
        itemStyle = {
          backgroundColor: '#ffcc66',
          color: "black",
          borderStyle: "solid",
          borderColor: "white"
        };
        break;
      case 4: // approved assignment
        itemStyle = {
          backgroundColor: 'gray',
          color: "black",
          borderStyle: "solid",
          borderColor: "white"
        };
        break;
      case 5: // placed/concurrent facility assignment
        itemStyle = {
          backgroundColor: '#c3e2fa',
          color: "black",
          borderStyle: "solid",
          borderColor: "white"
        };
        break;
      case 'offtime':
        itemStyle = {
          backgroundColor: '#686868',
          color: "white",
          borderStyle: "solid",
          borderColor: "white"
        };
        break;
      case 'dayOffRequest':
        itemStyle = {
          backgroundColor: "silver",
          color: 'yellow',
          borderStyle: "solid",
          borderColor: "white"
        };
        break;
        case 'pay-transaction':
          itemStyle = {
            backgroundColor: "#d5afe3",
            color: 'black',
            borderStyle: "solid",
            borderColor: "white"
          };
          break;
        case 'indicators':
          itemStyle = {
            backgroundColor: "#6441A4",
            color: 'white',
            borderStyle: "solid",
            borderColor: "white"
          };
          break;
      default:
        itemStyle = null;


    }
    return itemStyle;
  }
